import { useState, type FormEvent } from 'react'
import { AlertTriangle, Hammer } from 'lucide-react'
import { useAuth } from './AuthProvider'

export function LoginPage() {
  const { signIn, configured } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  async function submit(event: FormEvent) { event.preventDefault(); setError(''); setBusy(true); try { await signIn(email, password) } catch (reason) { setError(reason instanceof Error ? reason.message : 'Login failed.') } finally { setBusy(false) } }
  return <main className="login-screen">
    <section className="login-panel" aria-labelledby="login-title">
      <div className="brand-lockup"><span className="brand-mark"><Hammer size={15}/></span><div><strong>Catalyst Forge</strong><span>CatalystSuite staff access</span></div></div>
      <h1 id="login-title">Staff Login</h1>
      <p>Use the account invited by your workspace owner.</p>
      {!configured ? <div className="callout error"><AlertTriangle size={16}/><div><strong>Supabase is not configured</strong><span>Add the two Vite environment variables described in the README, then restart the app.</span></div></div> :
      <form onSubmit={submit} className="stack">
        <label>Email<input type="email" autoComplete="username" required value={email} onChange={(event) => setEmail(event.target.value)}/></label>
        <label>Password<input type="password" autoComplete="current-password" required value={password} onChange={(event) => setPassword(event.target.value)}/></label>
        {error && <div className="inline-error" role="alert">{error}</div>}
        <button className="button primary" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
      </form>}
      <small>No public registration. Contact the workspace owner for access.</small>
    </section>
  </main>
}
